import { Change as Change1 } from "src/features/changelog/changes/1";
import { Change as Change2 } from "src/features/changelog/changes/2";
import { Change as Change3 } from "src/features/changelog/changes/3";
import { Change as Change4 } from "src/features/changelog/changes/4";
import { Change as Change5 } from "src/features/changelog/changes/5";
import { Change as Change6 } from "src/features/changelog/changes/6";
import { Change as Change7 } from "src/features/changelog/changes/7";
import { Change as Change8 } from "src/features/changelog/changes/8";
import { Change as Change9 } from "src/features/changelog/changes/9";
import { Change as Change10 } from "src/features/changelog/changes/10";
import { Change as Change11 } from "src/features/changelog/changes/11";
import { Change as Change12 } from "src/features/changelog/changes/12";
import { Change as Change13 } from "src/features/changelog/changes/13";
import { ChangelogItem } from "src/features/changelog/changes/types";

// note: empty modules means it's relevant for all
// note: the first one should be the latest one - ALWAYS PREPEND!!!
export const changes: ChangelogItem[] = [
	{ date: "2025/09/29", content: Change13, modules: ["ktx", "kd"] },
	{ date: "2025/09/08", content: Change12, modules: ["ktx", "kd"] },
	{ date: "2025/07/25", content: Change11, modules: ["ktx", "kd"] },
	{ date: "2025/06/27", content: Change10, modules: ["ktx", "kd"] },
	{ date: "2025/03/12", content: Change9, modules: [] },
	{ date: "2025/02/13", content: Change8, modules: ["htx"] },
	{ date: "2024/12/11", content: Change7, modules: ["ktx", "kd"] },
	{ date: "2024/11/25", content: Change6, modules: ["ktx", "kd"] },
	{ date: "2024/07/19", content: Change5, modules: ["ktx", "kd"] },
	{ date: "2024/05/28", content: Change4, modules: ["ktx", "kd"] },
	{ date: "2022/11/17", content: Change3, modules: [] },
	{ date: "2022/08/26", content: Change2, modules: [] },
	{ date: "2022/06/07", content: Change1, modules: [] }
];
